import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { observe: String }

  connect() {
    if (this.hasObserveValue) {
      const observed = this.element.closest(this.observeValue)
      if (!observed) return

      this.resizeObserver = new ResizeObserver(() => this.element.scrollIntoView())
      this.resizeObserver.observe(observed)
    }

    setTimeout(() => this.element.scrollIntoView(), 500)
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }
}